import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=59d85fce&scoped=true"
import script from "./order_detail.vue?vue&type=script&lang=js"
export * from "./order_detail.vue?vue&type=script&lang=js"
import style0 from "./order_detail.vue?vue&type=style&index=0&id=59d85fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d85fce",
  null
  
)

export default component.exports